import { api } from './client';

/** Fichas de proyecto del dueño (tanda 3, Ola D). Prefijo /api/proyectos, del módulo `proyectos`. */
export interface Proyecto {
  id: string;
  nombre: string;
  zona: string;
  precioDesdeUsd: number;
  inicialMinimaPct: number | null;
  entrega: string | null;
  amenidades: string[];
  fotos: Array<{ key: string; url: string }>;
  brochureUrl: string | null;
  /** Tanda 5: sus videos. */
  videos: Array<{ key: string; url: string }>;
  /** Tanda 5: su página en la web del dueño. */
  enlace: string | null;
  /** 'YYYY-MM-DD'. */
  vigenteHasta: string;
  /** 0 = vence hoy; negativo = ya venció. */
  venceEnDias: number;
  /** ¿El agente lo puede nombrar? */
  vigente: boolean;
  noRecomendar: boolean;
}

export interface DatosDeProyecto {
  nombre: string;
  zona: string;
  precioDesdeUsd: number;
  inicialMinimaPct: number | null;
  entrega: string | null;
  amenidades: string[];
  /** Claves del storage. */
  fotos: string[];
  /** Claves del storage de los videos (subirVideo). */
  videos: string[];
  /** Solo http(s). null = sin enlace. */
  enlace: string | null;
  vigenteHasta: string;
  noRecomendar: boolean;
}

export const listarProyectos = () => api.get<{ proyectos: Proyecto[]; zonas: string[] }>('/api/proyectos');
export const crearProyecto = (d: DatosDeProyecto) => api.post<Proyecto>('/api/proyectos', d);
export const editarProyecto = (id: string, d: Partial<DatosDeProyecto>) => api.patch<Proyecto>(`/api/proyectos/${id}`, d);
export const borrarProyecto = (id: string) => api.del<{ ok: true }>(`/api/proyectos/${id}`);

/** Sube el brochure en PDF (multipart), como el logo y las fotos del catálogo. */
export const subirBrochure = (id: string, archivo: File) => {
  const form = new FormData();
  form.append('file', archivo);
  return api.post<{ key: string; url: string }>(`/api/proyectos/${id}/brochure`, form);
};

/** El tope del servidor (multipart) y lo que se le dice al dueño si lo pasa. */
export const VIDEO_MAX_BYTES = 25 * 1024 * 1024;
export const VIDEO_MUY_PESADO = 'El video pesa más de 25 MB. Comprímelo o súbelo a YouTube y pega el enlace en el proyecto.';

/**
 * Tanda 5: sube un video MP4 o MOV (de un proyecto o de presentación) y devuelve su
 * clave, que se guarda al guardar. Uno de más de 25 MB ni se manda: el servidor lo rechazaría
 * después de esperar toda la subida.
 */
export const subirVideo = (archivo: File) => {
  if (archivo.size > VIDEO_MAX_BYTES) return Promise.reject(new Error(VIDEO_MUY_PESADO));
  const form = new FormData();
  form.append('file', archivo);
  return api.post<{ key: string; url: string }>('/api/proyectos/videos', form);
};
